import { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import styles from "./ShareReceiptModal.module.scss";
import Button from "../../../../../common/ekedc-components/button/Button";
import { BackIcon, ImageIcon, SharePdfIcon } from "../../../../../assets/icons";
import { TopBottomCuttedCard } from "../../../../../common/components/top-bottom-cutted-card/TopBottomCuttedCard";
import { useTenant } from "../../../../../tenant/branding/useTenant";
import LoadedImage from "../../../../../common/components/loaded-image/LoadedImage";

interface ShareReceiptModalProps {
	onClose: () => void;
	onShareImage: () => void;
	onSharePdf: () => void;
	receiptStyle?: React.CSSProperties;
	bgImage?: string;
	watermarkSrc?: string;
	children: React.ReactNode;
}

export const ShareReceiptModal = forwardRef<HTMLDivElement, ShareReceiptModalProps>(
	({ onClose, onShareImage, onSharePdf, receiptStyle, bgImage, watermarkSrc, children }, ref) => {
		const { t } = useTranslation();
		const { logo, name } = useTenant();
		return (
			<div className={styles.overlay} onClick={onClose}>
				<div className={styles.inner} onClick={e => e.stopPropagation()}>
					<div className={styles.header}>
						<div className={styles.headerLeft}>
							<BackIcon onClick={onClose} className={styles.closeBtn} />
							<span className={styles.title}>{t("history.shareReceipt")}</span>
						</div>
						<LoadedImage src={logo} alt={name} className={styles.logo} />
					</div>

					<div className={styles.body}>
						<TopBottomCuttedCard ref={ref} style={receiptStyle} bgImage={bgImage} watermarkSrc={watermarkSrc} className={styles.receiptInModal}>
							{children}
						</TopBottomCuttedCard>
					</div>

					<div className={styles.actions}>
						<Button variant="secondary" onClick={onShareImage}>
							<ImageIcon /> {t("common.labels.shareAsImage")}
						</Button>
						<Button variant="secondary" onClick={onSharePdf}>
							<SharePdfIcon /> {t("serviceRequest.shareAsPdf")}
						</Button>
					</div>
				</div>
			</div>
		);
	}
);

ShareReceiptModal.displayName = "ShareReceiptModal";
